import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';
// mock
import { LazyLoadImage } from 'react-lazy-load-image-component';
import account from '../../_mock/account';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
//
import navConfig from './NavConfig';
import navConfigOrg from './NavConfigOrg';
import NavSection1 from '../../components/NavSection1';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 250;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
}));

// ----------------------------------------------------------------------

DashboardSidebarOrg.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebarOrg({ isOpenSidebar, onCloseSidebar, banner, logo, name }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {

    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      

      <div
            style={{
              backgroundImage: `url(${banner})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundColor: '#f2f2f2',
              height: '130px',
              width: '100%',
              display: 'flex',
              borderRadius: '7px',
              alignItems: 'center',
              
            }}
          >
            <div style={{
              backgroundColor: 'rgba(0, 0, 0, 0.40)',
              height: '130px',
              width: '100%',
              display: 'flex',
              padding: 5,
              borderRadius: '7px',
              alignItems: 'center',
            }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="start"
                mb={3}
                spacing={2}
                sx={{
                  width: '100%',
                  padding: 2,
                }}
              >
                <Avatar src={logo} sx={{ width: 60, height: 60 }} />
                <Stack direction="column" alignItems="start" justifyContent="center" sx={{ color: 'white', }}>
                  <Typography sx={{ color: 'white', }} variant="h5" gutterBottom>
                    {name}
                  </Typography>
                </Stack>
              </Stack>
            </div>

          </div>


      <NavSection1 navConfig={navConfigOrg} />

      <Box sx={{ flexGrow: 1 }} />

    </Scrollbar>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH, bgcolor: '#5E17EB',
              borderRightStyle: 'hidden',
            },

          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: '#5E17EB',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
